import { TableCell } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import Check from '@material-ui/icons/Check';
import { toast } from 'react-toastify';

const TableClientCheckboxSection = ({
  mailingOption,
  t,
  setAllowToChangedElements,
  state,
  setState,
  classes,
}) => (
  <TableCell>
    {/* eslint-disable-next-line no-negated-condition -- FIXME */}
    {!mailingOption.managedBySystem ? (
      <Checkbox
        checked={
          mailingOption.managedBySystem ? false : mailingOption.enabledForClient
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars, consistent-return -- FIXME
        onChange={e => {
          setAllowToChangedElements();
          if (mailingOption.managedBySystem) {
            return toast.warning(
              `${t('mailNotifications.thisIsASystemNotification')} ${t(
                'mailNotifications.systemNotificationAvailableOnlyForAdministratrs'
              )}`
            );
          }

          const newMailing = [...state.mailing];

          const optionToChange = newMailing.find(
            newMailingOption => newMailingOption.id === mailingOption.id
          );

          optionToChange.enabledForClient = !mailingOption.enabledForClient;
          optionToChange.hasChanged = true;

          setState({
            mailing: newMailing,
          });
        }}
        checkedIcon={<Check className={classes.checkedIcon} />}
        icon={<Check className={classes.uncheckedIcon} />}
        classes={{
          checked: classes.checked,
          root: classes.checkRoot,
        }}
      />
    ) : (
      '-'
    )}
  </TableCell>
);

export default TableClientCheckboxSection;
